import React from "react";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import UseSquadflixNavigate from "../useSquadflixNavigate";
import ItemBackdropDetails from "../../shared/item-backdrop-details/item-backdrop-details";
import useUserPreferences from "../../../user-app-config/hooks/use-user-preferences";
import {dateIsToday} from "../../../../utils/utils";
import {useIntl} from "react-intl";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import {useNewEpisodesData} from "../../hooks/useCatalogRowData";

type Props = SquadflixRowsBaseProps & {
    onClickEpisode?: (item: any) => void;
}

const NewEpisodesRow = (props: Props) => {
    const {onClickEpisode} = props;
    const {series: futureEpisodesSeries, loading} = useNewEpisodesData();
    const squadflixNav = UseSquadflixNavigate({});
    const {userPreferences, loading: loadingPreferences} = useUserPreferences();
    const intl = useIntl();

    const handleClickEpisode = (serie) => {
        const airDate = new Date(serie.next_episode_to_air.air_date);
        const airedToday = dateIsToday(airDate);

        if (airedToday) {
            const episode = serie.next_episode_to_air;
            if (onClickEpisode) {
                onClickEpisode(episode)
            } else {
                squadflixNav.navigateToEpisode(episode)
            }
        }
    }

    if (loading) return null;
    if (!futureEpisodesSeries || futureEpisodesSeries.length === 0) return null;
    return (
        <div style={{height: "fit-content", overflow: "hidden", order: props.order ?? 0}}>
            <SquadflixRowTitle
                {...props}
                title={intl.formatMessage({id: "squadflix-home.new-episodes"})}
                icon={<i className="fa-regular fa-calendar-days"></i>}/>
            <ItemsHorizontalScroll>
                <div className="d-flex flex-row gap-3" style={{paddingLeft: "13px", paddingRight: "13px"}}>
                    {futureEpisodesSeries.map((item) => {
                        const airDate = new Date(item.next_episode_to_air.air_date);
                        const airedToday = dateIsToday(airDate);
                        const episode = item.next_episode_to_air;
                        const isSpoiler = (userPreferences.hideSpoilers || userPreferences.hideSpoilers == null || loadingPreferences)

                        return (<div key={item.id}>
                            <ItemBackdropDetails
                                onClickPoster={() => handleClickEpisode(item)}
                                onClickDetails={() => squadflixNav.navigateToSerie(item)}
                                style={{
                                    width: "min(300px, 59vw)",
                                    position: "relative",
                                }}
                                overlay={{
                                    center: airedToday && <i className="fa-solid fa-play fa-xl" style={{
                                        padding: "10px 7px",
                                    }}></i>,
                                    topLeft: !airedToday && <>Proximamente...</>
                                }}
                                tmdbSrc={item.backdrop_path}
                                detailsInfo={airedToday ?
                                    intl.formatMessage({id: "squadflix-home.new-episodes.see-now"}) :
                                    <>Disponible el {airDate.toLocaleDateString()}</>}
                                detailsTitle={item.name}
                                detailsSubtitle={isSpoiler ? `Temporada ${episode.season_number} Episodio ${episode.episode_number}` : `S${episode.season_number}:E${episode.episode_number} - ${episode.name}`}
                            />
                        </div>)
                    })}
                </div>
            </ItemsHorizontalScroll>
        </div>
    );
};

export default NewEpisodesRow;
